import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { get, getJson } from 'session';
import Modal from 'modules/common/components/Modal';
import PrintIFrame from 'modules/common/components/PrintIFrame';

function DistributorReportModal({
  date_from,
  date_to,
  module_type,
}) {

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const [printLink, setPrintLink] = useState();

  const generateLink = () => {
    const url = `${process.env.REACT_APP_WS}api/v1/bpls/administrator/report/distribution_report_by_revenue_account/generate/?module_type=${module_type}&date_from=${date_from}&date_to=${date_to}&bearer_token=${token}&email=${_.get(authProfile, 'email')}&output=I`;
    setPrintLink(url);
  };

  const renderFrame = () => {
    if (!_.isEmpty(date_from) && !_.isEmpty(date_to)) {
      if (!_.includes(printLink, undefined)) {
        return <PrintIFrame url={printLink} />;
      }
    }
    return null;
  };

  useEffect(() => {
    generateLink();
  }, []);

  useEffect(() => {
    generateLink();
  }, [date_from, date_to]);

  return (
    <Modal.Body>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0 animated-spinner">
            {renderFrame()}
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

DistributorReportModal.propTypes = {
  date_from: PropTypes.string,
  date_to: PropTypes.string,
  module_type: PropTypes.string,
};

DistributorReportModal.defaultProps = {
  date_from: '',
  date_to: '',
  module_type: '',
};

export default DistributorReportModal;
